import UshkSwitch from './Switch.vue'
import FlashList from './FlashList.vue'
import UshkPrice from './Price'
import Skeleton from './Skeleton'

const components = {
  UshkSwitch,
  FlashList,
  UshkPrice,
  Skeleton
}

export default function install (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })
}



// WEBPACK FOOTER //
// ./src/views/index/modules/index.js